<template>
  <button class="btn btn-link mb-2" type="button" @click="onClick">
    <i class="bi bi-file-earmark-arrow-down" /> {{ $t("exportar") }}
  </button>
</template>

<script>
import { getAllVisionOneData } from '../visionOneService';

export default {
  props: {
    headers: { type: Array, required: true },
    sort: { type: String, required: true },
    order: { type: String, required: true },
    creationInitialDate: { type: String, default: '' },
    creationEndDate: { type: String, default: '' },
    closingInitialDate: { type: String, default: '' },
    closingEndDate: { type: String, default: '' },
    search: { type: String, default: '' },
    status: { type: Array, default: () => [] },
    tipo: { type: Array, default: () => [] },
  },
  methods: {
    async onClick() {
      const rows = await getAllVisionOneData(this.$props);
      rows.unshift(this.headers.slice(1));
      const content = 'data:text/csv;charset=utf-8,\ufeff' + rows.map((e) => e.join(';')).join('\n');
      const encodedUri = encodeURI(content);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'Lista de OSs.csv');
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
